import {z as zod} from "zod";

export type WorkspaceResourceCounts = {
    creators: number;
    dataSources: number;
    users: number;
    viewers: number;
};

export const workspaceResourceCountsZodValidator: zod.ZodType<WorkspaceResourceCounts> = zod.object({
    creators: zod.number(),
    dataSources: zod.number(),
    users: zod.number(),
    viewers: zod.number(),
});

export type WorkspaceResourceInformation = {
    currentCounts: {
        dataSources: number;
        users: number;
    };
    limits: WorkspaceResourceCounts;
};

export const workspaceResourceInformationZodValidator: zod.ZodType<WorkspaceResourceInformation> = zod.object({
    currentCounts: zod.object({
        dataSources: zod.number(),
        users: zod.number(),
    }),
    limits: workspaceResourceCountsZodValidator,
});
